import "../Css/portfolio.css";
import React, { useState, useEffect } from "react";

const Portfolio = ({ tiles = [] }) => {
    function useIsSmallScreen() {
        const [isSmallScreen, setIsSmallScreen] = useState(window.innerWidth < 871);

        useEffect(() => {
            const handleResize = () => {
                setIsSmallScreen(window.innerWidth < 871);
            };

            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }, []);

        return isSmallScreen;
    }
    const isSmallScreen = useIsSmallScreen();

    return (
        <section className="portfolio-container">
            <h2 className="portfolio-title">Aplicaciónes Web</h2>
            <div className="portfolio-grid">
                {tiles.map((tile, index) => (
                    <a
                        key={index}
                        href={tile.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        className={`portfolio-tile ${tile.className || ""}`}
                    >

                        {isSmallScreen && (<img src={tile.srcSm || tile.src} alt={tile.alt} className="tile-image" loading="lazy" />)}
                        {!isSmallScreen && (<img src={tile.src} alt={tile.alt} className="tile-image" loading="lazy" />)}
                    </a>
                ))}
            </div>
            <p style={{ color: "#52525293", margin: "0", letterSpacing:"0rem"}}>Proyectos de sus autores, exhibidos como ejemplo. ClustTec® no posee derechos.</p>

        </section>
    );
};

export default Portfolio;

